import React from 'react';
import Udesk from 'Udesk';
import SoundtrackManageIndexRoute from './route';
import FilterManage from '../components/filter-manage';
import ListManage from '../components/soundtrack-list-manage';
import './style.scss';
import UdeskLocales from 'UdeskLocales';
// import UdeskLocales from 'UdeskLocales';

export default class SoundtrackManageIndexTemplate extends SoundtrackManageIndexRoute {
    render() {
        let { filterVisible, isUpdate, keyword } = this.privates;
        let { selectedFilter } = this.privates.storages;
        let { actions, locales } = this;

        return (
            <div className="udesk-qa-web-page">
                <div className="udesk-qa-web-page-body">
                    <div className="udesk-qa-web-page-body-root soundtrack-manage-page">
                        <div className="soundtrack-manage-page-left-part">
                            <FilterManage
                                ref={this.privates.filterManageRef}
                                type={Udesk.enums.filterTypes.soundtrackManage.id}
                                filterManageTitle={/* 原声管理 */UdeskLocales['current'].pages.soundtrackManage.template.originalSoundManagement}
                                onEditFilter={actions.editFilter}
                                allFilterTitle={/* 全部原声 */UdeskLocales['current'].pages.soundtrackManage.template.allSonic}
                                onSelectedFilterChanged={actions.onSelectedFilterChanged}
                                isUpdate={isUpdate}
                            />
                        </div>
                        <div className="soundtrack-manage-page-right-part">
                            <ListManage
                                title={/* 原声管理 */UdeskLocales['current'].pages.soundtrackManage.template.originalSoundManagement}
                                cacheKey="e-comment-manage.index"
                                searchPlaceHolder={locales.labels.searchPlaceHolder}
                                type={Udesk.enums.filterTypes.soundtrackManage.id}
                                editFilterVisible={filterVisible}
                                onEditFilterVisibleChanged={actions.onEditFilterVisibleChanged}
                                onPageChanged={actions.onPageChanged}
                                selectedFilter={selectedFilter}
                                onConditionFilterSaved={actions.onConditionFilterSaved}
                                keyword={keyword}
                                hideKeywordType
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
